import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';
import { InsuranceTypesEnum, tInsuranceTypeEnum } from '@models/InsuranceType';
import { PaymentMethods } from '@models/PaymentInfo';
import { selectHealthPolicyClaim } from './selector';
import { FormValues, formValuesSchema } from './schema';

export const useInitialValues = () => {
  const { policy, insurancePolicyUser } = useSelector(selectHealthPolicyClaim);
  const initialValues: FormValues = formValuesSchema.getDefault() as unknown as FormValues;

  return useMemo(() => {
    merge(initialValues, {
      policyHolder: insurancePolicyUser?.name ?? '',
      policyHolderDob: insurancePolicyUser?.dob ?? '',
      policyHolderGender: insurancePolicyUser?.gender ?? '',
      policyNumber: policy?.policyNumber ?? '',
      policyPlanType: `${tInsuranceTypeEnum((policy?.insuranceType as InsuranceTypesEnum) ?? '')} - ${insurancePolicyUser?.benefitTemplate.name ?? ''}`,
      policyExpiryDate: insurancePolicyUser?.expirationDate ?? '',
      mobileNumber: insurancePolicyUser?.mobileNumber ?? '',
      email: insurancePolicyUser?.email ?? '',
      paymentInfo: {
        beneficiaryName: insurancePolicyUser?.name ?? '',
        paymentMethod: PaymentMethods.BankTransfer,
      },
    });

    return initialValues;
  }, [policy, insurancePolicyUser]);
};
